"use client";

import { Button, Subtitle2, Title3 } from "@fluentui/react-components";
import { GlobeErrorRegular } from "@fluentui/react-icons";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  const t = useTranslations();
  const pathname = usePathname();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    console.error("[ERROR] Client-side error caught:", error?.message, error);
  }, [error]);

  // Soft-nav can leave the error boundary stuck; recover when the route changes.
  useEffect(() => {
    if (prevPathnameRef.current !== pathname) {
      prevPathnameRef.current = pathname;
      reset();
    }
  }, [pathname, reset]);

  return (
    // <div className="flex flex-col items-center justify-center h-screen text-center px-4">
    //   <h1 className="text-4xl font-bold mb-4">Oops! Something went wrong.</h1>
    //   <p className="text-lg mb-6">A client-side error occurred. Try refreshing or go back.</p>
    //   <button onClick={() => reset()} className="bg-blue-600 text-white px-4 py-2 rounded">
    //     Try Again
    //   </button>
    // </div>
    <div className="flex items-center justify-center w-full min-h-screen">
      <section className="bg-neutral-background-1">
        <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
          <div className="flex flex-col items-center justify-center gap-4 mx-auto max-w-screen-sm text-center">
            <GlobeErrorRegular className="text-9xl" />
            <Title3 className="text-neutral-foreground-1">{t("error.page.error.title")}</Title3>
            <Subtitle2 className="text-neutral-foreground-3">{t("error.page.error.msg")}</Subtitle2>
            {error?.message ? (
              <Subtitle2 className="text-neutral-foreground-3 break-all">{error.message}</Subtitle2>
            ) : null}
            <Link href="/">
              <Button appearance="primary" size="large">
                {t("common.btn.back_to_home")}
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
